module.exports = __webpack_public_path__ + "img/serbia-logo-icon.9a63c384.png";